__turbopack_context__.v({
  "menu": "Menu-module__9dg8zq__menu",
  "menu__left": "Menu-module__9dg8zq__menu__left",
  "menu__right": "Menu-module__9dg8zq__menu__right",
  "menu__right__phone": "Menu-module__9dg8zq__menu__right__phone",
  "menu__right__social": "Menu-module__9dg8zq__menu__right__social",
  "phoneicon": "Menu-module__9dg8zq__phoneicon",
  "socialIcon": "Menu-module__9dg8zq__socialIcon",
});
